import { render, staticRenderFns } from "./Subsecuente.vue?vue&type=template&id=5f649614&scoped=true&"
import script from "./Subsecuente.vue?vue&type=script&lang=js&"
export * from "./Subsecuente.vue?vue&type=script&lang=js&"
import style0 from "./Subsecuente.vue?vue&type=style&index=0&id=5f649614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f649614",
  null
  
)

export default component.exports